import Baunebakken from './Baunebakken';

export default Baunebakken;